import React from "react";
import styled from "styled-components";
import { withTranslation } from "react-i18next";
import { AgGridReact } from "ag-grid-react";
import {
  ClientSideRowModelModule,
  ModuleRegistry,
  TooltipModule,
} from "ag-grid-community";
import "ag-grid-community/styles/ag-grid.css"; // Mandatory CSS required by the Data Grid
import "ag-grid-community/styles/ag-theme-quartz.css"; // Optional Theme applied to the Data Grid

// Register all Community features
ModuleRegistry.registerModules([ClientSideRowModelModule, TooltipModule]);

// Style that allows dropdowns to appear on top of grid rows
const GridWrapper = styled.div`
  & .ag-row.ag-row-focus {
    z-index: 1;
  }
`;

// Without a stable row id, ag-grid can lose track of rows across re-renders
// (e.g. new columnDefs/rowData array references on every parent render),
// which shows up as a row being present in the data but not rendering until
// something forces a full recompute, like re-sorting.
function getRowId(params) {
  return `${params.data.id}`;
}

function BasicTable({ columns, data }) {
  return (
    <GridWrapper>
      <div className="ag-theme-quartz" style={{ height: 500 }}>
        <AgGridReact
          rowData={data}
          columnDefs={columns}
          getRowId={getRowId}
          pagination={true}
          tooltipShowDelay={500}
          tooltipInteraction={true}
        />
      </div>
    </GridWrapper>
  );
}

export default withTranslation()(BasicTable);
